/*** IMPORTS FROM imports-loader ***/
var define = false;

function scrollWaypointInit( items, trigger ) {
  items.each( function() {
    var element = $(this),
        osAnimationClass = element.data("animation"),
        osAnimationDelay = element.attr('data-animation-delay');

    var trigger = ( trigger ) ? trigger : element;

    trigger.waypoint(function() {
        element.addClass('animate__animated').addClass(osAnimationClass);
        if (element.attr('data-animation-delay')){
          element.addClass('animate__delay-'+(osAnimationDelay));
        }
    },{
       // triggerOnce: true,
        offset: '100%'
    });
  });
}

jQuery(document).ready(function(){

  scrollWaypointInit( $('.animated') );

});

